import { motion } from "framer-motion";
import { useLenis } from "lenis/react";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, ...rest }) => (
  <div
    className="flex items-center gap-3 font-mono text-[11px] tracking-[0.35em] text-skope uppercase"
    {...rest}
  >
    <span className="w-1.5 h-1.5 rounded-full bg-skope shrink-0" />
    {children}
  </div>
);

export const useScrollTo = () => {
  const lenis = useLenis();
  return (target) => {
    if (lenis) lenis.scrollTo(target, { offset: -64, duration: 1.4 });
    else document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  };
};

export const OPS_OPTION = "End-to-End Kitchen Operations (Take Over My Operations)";

export const preselectBuilding = (option) =>
  window.dispatchEvent(new CustomEvent("skope:preselect-building", { detail: option }));

export const openSchedule = (snapshot) =>
  window.dispatchEvent(new CustomEvent("skope:open-schedule", { detail: snapshot || null }));
